import { Link } from "@tanstack/react-router";

export default function NotFound() {
  return (
    <div className="d-flex justify-content-center h-100 align-items-center">
      <div className="text-center">
        <h1 className="display-1 mb-3">404</h1>
        <p className="text-muted">We seem to have misplaced that page.</p>
        <Link to="/" className="btn btn-primary ml-1">
          Back to Home
        </Link>
      </div>
    </div>
  );
}
